import moment from 'moment-timezone'
import { getDistanceToFinalStop } from 'utils/mapbox'
import {
  GEOCODE_ACTION_TYPES,
  PREVIOUS_DIRECTIONS_ACTION_TYPES,
  PREDICTED_DIRECTIONS_ACTION_TYPES,
} from '../actions/mapbox'

const defaultState = {
  isFetching: null,
  query: [],
  features: [],
  routes: [],
  previousRoute: [],
  predictedRoute: [],
  waypoints: [],
  error: null,
}

const { GEOCODE_FAILURE, GEOCODE_SUCCESS, REQUEST_GEOCODE } = GEOCODE_ACTION_TYPES

const {
  PREVIOUS_DIRECTIONS_FAILURE,
  PREVIOUS_DIRECTIONS_REQUEST,
  PREVIOUS_DIRECTIONS_SUCCESS,
} = PREVIOUS_DIRECTIONS_ACTION_TYPES

const {
  PREDICTED_DIRECTIONS_FAILURE,
  PREDICTED_DIRECTIONS_REQUEST,
  PREDICTED_DIRECTIONS_SUCCESS,
} = PREDICTED_DIRECTIONS_ACTION_TYPES

const mapboxReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case REQUEST_GEOCODE: {
      return {
        ...state,
        isFetching: true,
      }
    }
    case GEOCODE_SUCCESS: {
      const {
        payload: { query = [], features = [] },
      } = action || {}
      return {
        ...state,
        query,
        isFetching: false,
        features,
      }
    }
    case GEOCODE_FAILURE: {
      const {
        payload: { error },
      } = action || {}
      return {
        ...state,
        isFetching: false,
        error,
      }
    }
    case PREDICTED_DIRECTIONS_REQUEST: {
      return {
        ...state,
        isFetching: true,
        routes: [],
        predictedRoute: [],
      }
    }
    case PREDICTED_DIRECTIONS_SUCCESS: {
      const {
        data: { currentStopIndex, stops },
        payload: { routes = [], waypoints = [] },
      } = action
      const finalStopDistanceMiles = getDistanceToFinalStop(routes)
      const nextStop = stops[currentStopIndex]
      const nextStopDurationSeconds = routes[0]?.duration
      const nextStopEstimate = moment().add(nextStopDurationSeconds, 'seconds').startOf('minute')
      const nextStopTime = nextStopEstimate.tz(nextStop.appointment.timezone)
      return {
        ...state,
        isFetching: false,
        routes,
        predictedRoute: routes,
        waypoints,
        calculatedData: {
          finalStopDistanceMiles,
          nextStopTime,
        },
      }
    }
    case PREDICTED_DIRECTIONS_FAILURE: {
      const {
        payload: { error },
      } = action
      return {
        ...state,
        isFetching: false,
        error,
      }
    }
    case PREVIOUS_DIRECTIONS_REQUEST: {
      return {
        ...state,
        isFetching: true,
        routes: [],
        previousRoute: [],
      }
    }
    case PREVIOUS_DIRECTIONS_SUCCESS: {
      const {
        data: { currentStopIndex, stops },
        payload: { routes = [], waypoints = [] },
      } = action
      const finalStopDistanceMiles = getDistanceToFinalStop(routes)
      const nextStop = stops[currentStopIndex]
      const nextStopDurationSeconds = routes[0]?.duration
      const nextStopEstimate = moment().add(nextStopDurationSeconds, 'seconds').startOf('minute')
      const nextStopTime = nextStopEstimate.tz(nextStop.appointment.timezone)
      return {
        ...state,
        isFetching: false,
        routes,
        previousRoute: routes,
        waypoints,
        calculatedData: {
          finalStopDistanceMiles,
          nextStopTime,
        },
      }
    }
    case PREVIOUS_DIRECTIONS_FAILURE: {
      const {
        payload: { error },
      } = action
      return {
        ...state,
        isFetching: false,
        error,
      }
    }
    default:
      return state
  }
}

export default mapboxReducer
